import { Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { FileUploader } from 'ng2-file-upload';

import { ApiService } from '../services/api.service'
import { ConsultDetail } from '../containers/index';
import { CnsltnCntrModel } from '../services/index';
import { REST_API_REQUEST_CALL_URL } from '../utils/rest-api-request-url';
import { CnsltnFwdrModel } from './quotation.service';


export class CargoTrackList {
  activeYn: string;
  blNo: string;
  cargoTrackStatus: string;
  cargoTrackStatusNm: string;
  cntrNo: string;
  crgoInfoList: Array<any>;
  curVesselInfo: ShipementVsl;
  custCorpNm: string;
  custNm: string;
  custOrderId: string;
  displayYn: string;
  existTrackingInfo: boolean;
  imexTp: string;
  oceanLine: {
    lineCd: string;
    lineNm: string;
    lineNm2: string;
  };
  possibleModify: boolean;
  summaryInfo: SummaryInfo;
  trackMstId: string;
  transTp: string;
  vesselInfoList: ShipementVsl[];
  //이하 커스텀
  progress: number;
  markerUrl: any;
  isVslOrShipment: string;
  initEtd: string;
  initEta: string;
  imexTpString: string;

  constructor() {
    this.isVslOrShipment = 'shipment';
  }
}

export class ConsultReqCargo {
  reqNo:string;
	reqTp:number;
	crgoSeq:number;
	commodity:string;
	count:number;
	weight:number;
	value:number;
	crgoTp:string;
	crgoSz:string;
	rfYn:number;
	dgYn:number;
	width:number;
	length:number;
	height:number;
	cbm:number;
	wghtUnit:string;
	volUnit:string;
	pkgUnit:number;
	hsCode:string;
	temp:number;
	tempUnit:string;
	ventilation:string;
}

export class Consult {
  reqNo:string;
	reqTp:number;
	transTp:number;
	reqDtm:string;
	delYn:number;
	delDtm:string;
	stusCd:number;
	cnfrmDtm:string;
	sender:string;
	receiver:string;
	orgTp:number;
	orgCntryCd:string;
	orgCntryNm:string;
  orgAdrs:string;
  orgAdrsDtl:string;
	desTp:number;
	desCntryCd:string;
	desCntryNm:string;
  desAdrs:string;
  desAdrsDtl:string;
	imexTp:number;
	inctms:string;
	transExptDt:string;
	other:string;
	quotNo:string;
	linerNm:string;
	transNm:string;
	quotCnt:number;
	quotCntForFrnt:number;
	mBlNo:string;
	hBlNo:string;
	blYy:string;
	recvAdmin:string;
	recvAdminNm:string;
	recvAdminTel:string;
	reqSrvcLst:Array<string> = [];
  crgoLst:Array<ConsultReqCargo> = [];
  modifyDtm:string;
}

export class ConsultComment {
  cmnt:string;
  insDtm:number;
  insUsr:string;
  reqNo:string;
}


export class ShipementVsl {
  actualStatus: string; //WAIT, COMPLETE, TRANSPORTING
  arrLocationInfo: LocationInfo;
  ata: string;
  atd: string;
  attime: number;
  callSign: string;
  complete: boolean;
  course: number;
  depLocationInfo: LocationInfo;
  detailKey: string;
  eta: string;
  etd: string;
  ettime: number;
  heading: number;
  imoNo: string;
  latitude: number;
  longitude: number;
  mmsi: string;
  navCode: string;
  navCodeNm: string;
  speed: number;
  transporting: boolean;
  ttime: number;
  turn: number;
  vesselId: number;
  vesselNm: string;
  wait: boolean;
  progress: number;
  markerUrl: any;
  initEta:string;
  initEtd:string;
  trackSubId: string;
  trackingVslId: number;
}

export class SummaryInfo {
  arrLocationInfo: LocationInfo;
  ata: string;
  atd: string;
  cargoActionStatus: string;
  depLocationInfo: LocationInfo;
  eta: string;
  etd: string;
  ttime: number;
  //이하 for grid
  ataOrEta:string;
  atdOrEtd:string;
}


export class LocationInfo {
  latitude: number;
  locationCd: string;
  locationId:number;
  longitude: number;
  name: string;
  nameKr: string;
  unCd: string;
  cntryCd: string;
  cntryKr: boolean;
  portGroupIds: Array<number>;
  timeZone: number;
}


export class ShipmentShipLog {
  mmsi: string;
  transLogList: ShipLog[];
  vesselId: number;
  vesselNm: string;
}

export class ShipLog {
  mmsi: string;
  vesselName: string;
  imo: number;
  callSign: string;
  status: string;
  depPortName: string;
  depEtdAtd: string;
  arrPortName: string;
  arrEtdAta: string;
  latitude: number;
  longitude: number;
  speed: number;
  portCallLogs: Array<any>;
  received: string;
  vendor:string;
}
export class PortCallLog {
  locationId: number;
  locationName: string;
  latitude: number;
  locationCd:string;
  longitude: number;
  groupLocationId: Array<number>;
  timeZone:number;
  ata: string;
  atd: string;
  eta: string;
  etd: string;
  insert: boolean;
}

export class ShipmentPortCall {
  mmsi:string;
  portCallLogList: PortCallLog[];
  vesselId: number;
  vesselNm: string;
}

export class PortcallIndexObject {
  index:number;
  index2:number;
}

export class PortCallList {
  index: number;
  index2: number;
  log: PortCallLog; 
}

export class ShedAddress {
  snarAddr:TextString;
  snarSgn: TextString;
  snarNm: TextString;
  snartelno: TextString;
}

export class TextString {
  _text: string;
}

@Injectable()
export class ConsultRequestService {
  public param:any;
  
  isCopying:boolean = false;

  constructor(private http: Http, private apiService:ApiService) {};


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  // getConsultList() {
  //   return this.apiService.get('consult');
  // }

  getConsultDetail(id) {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CONSULT_REPORT_URL + id);
	}
	
	getCurrency(cntryCd:string): Observable<any> {
		return this.apiService
							.get(REST_API_REQUEST_CALL_URL.GET_CURRENCY + cntryCd)
							.map(res => {
								let jsonData = res;
								return jsonData.data.crncyMapId;
							});
	}

	reqConsult(uploader: FileUploader, consult: ConsultDetail): Observable<any> {
		return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_REQ_URL, consult, true).map(
			res => {
				let json = res;
				if (json.result && uploader.queue && uploader.queue.length > 0) {
					let reqNo = json.data;
					uploader.setOptions({
						url: REST_API_REQUEST_CALL_URL.POST_CONSULT_DOC + reqNo,
						additionalParameter: {
							docNm: 'MSDS',
							docTypeCd: '0'
						},
						headers: [
              {name: 'tx-clientid', value : 'tradlinx'},
              {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
            ]
					});
					uploader.queue.forEach((elem) => {
						elem.alias = 'docFile';
					});
					uploader.uploadAll();
				}
				return json;
			}
		);
  }

  editConsult(uploader: FileUploader, consult) {
    return this.apiService.post('admin/consult', consult, true).map(
      res => {
				let json = res;
				if (json.result && uploader.queue && uploader.queue.length > 0) {
					let reqNo = json.data;
					uploader.setOptions({
						url: REST_API_REQUEST_CALL_URL.POST_CONSULT_DOC + reqNo,
						additionalParameter: {
							docNm: 'MSDS',
							docTypeCd: '0'
						},
						headers: [
              {name: 'tx-clientid', value : 'tradlinx'},
              {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
            ]
					});
					uploader.queue.forEach((elem) => {
						elem.alias = 'docFile';
					});
					uploader.uploadAll();
				}
				return json;
      }
    );
	}

	cancelBooking(reqNo) {
    return this.apiService.post('consult/bookncancel', {reqNo: reqNo}, true);
	}
	
	copyConsultRequest(copy) {
    this.isCopying = copy;
	}
	
	deleteConsult(reqNo) : Observable<any> {
    return this.apiService.post('zimgo/consulting/shipper/legacy/cancel', { reqNo: reqNo }, true);
	}
	
	updateIsImpossibleConsult(data){
		return this.apiService.post('admin/consult/isImpossible', data, true);
	}

	reReqeustCnsltnReqEmail(reqNo){
		return this.apiService.post('admin/consult/emails', {reqNo:reqNo, type:'REQUEST_FOR_CONSULT'}, true);
	}

  completeCnsltnReq(reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CMPLT_REQ, { reqNo: reqNo }, true);
  }

  completeCancelCnsltnReq(reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CMPLT_CANCEL_REQ, { reqNo: reqNo }, true);
	}
	
	extendCloseEndDtm(reqNo){
		return this.apiService.patchReqDataType('admin/consult/' + reqNo + '/closeDtm/extension', { reqNo : reqNo });
	}

	doRequestToQuot(reqNo): Observable<any> {
    return this.apiService.post('admin/consults/'+ reqNo +'/stusCd/requestQuot', reqNo);
	}
	
	getCnsltnFwdrList(reqNo) : Observable<any> {
		return this.apiService.get('admin/consults/' + reqNo + '/fwdrs');
	}

	doRequestCnsltnFwdrs(reqNo:string, cnsltnFwdrList:Array<CnsltnFwdrModel>){
		// return this.apiService.post('admin/consults/' + reqNo + '/specificFwdrs', {reqNo:reqNo, cnsltnFwdrList:cnsltnFwdrList});
    return this.apiService.post('zimgo/consulting/inner/legacy/' + reqNo + '/specificFwdrs', {reqNo:reqNo, cnsltnFwdrList:cnsltnFwdrList});
	}

	insertNewCnsltnFwdrsOrUpdateDelYnCnsltnFwdrs(reqNo:string, cnsltnFwdrList:Array<CnsltnFwdrModel>){
		return this.apiService.patchReqBodyType('admin/consults/' + reqNo + '/fwdrs', {reqNo:reqNo, cnsltnFwdrList:cnsltnFwdrList});
	}

	changeCnsltnOwner(reqNo:string, userId:number){
		return this.apiService.patchReqBodyType('admin/consults/' + reqNo + '/user', {reqNo:reqNo, userId:userId});
	}

	getCnsltnType(reqTp:Number, transTp:Number):CnsltnType{
		if(reqTp == 0 && transTp == 0){
			return CnsltnType.FCL;
		}else if(reqTp == 1 && transTp == 0){
			return CnsltnType.LCL;
		}else if(reqTp == 1 && transTp == 1){
			return CnsltnType.AIR;
		}
	}

	getEntryCorpsInfo(reqNo:string){
		return this.apiService.get('admin/consults/' + reqNo + '/entry/coprs');
	}

	getTrackingInfo(reqNo:string) {
		return this.apiService.get('consult/track/' + reqNo + '/info');
	}

	getTrackingLog(reqNo:string) {
		return this.apiService.get('consult/track/' + reqNo + '/log');
	}

	getTrackingPortcall(reqNo:string) {
		return this.apiService.get('consult/track/' + reqNo + '/portcall');
	}
}

export enum CnsltnType{
		FCL = "FCL",
		LCL = "LCL",
		AIR = "AIR"
} 


// WEBPACK FOOTER //
// ./src/app/services/consults.service.ts